import React, { Component } from 'react';
import { Icon } from '@iconify/react';

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: this.props.display,
    };

    this.showContent = this.showContent.bind(this);
  }

  showContent() {
    this.setState({
      showContent: !this.state.showContent,
    });
  }
  render() {
    return (
      <div className="wrapper">
        <div className="accordion">
          <div className="item d-flex justify-content-start">
            <div>
              <span className="pointer text-color-grey">
                <Icon onClick={this.showContent} icon={`ri:arrow-drop-${this.state.showContent ? 'down' : 'right'}-line`} color="#075978b8" width="30" height="30" />
                {this.props.accrodionHeaderContent && this.props.accrodionHeaderContent()}
              </span>
            </div>
            <div className="title">
              <h6 className="text-right element_center">{this.props.title}</h6>
            </div>
          </div>

          <div className={this.state.showContent ? 'content show' : 'content'}>
            {this.props.content && this.props.content()}
          </div>
        </div>
      </div>
    );
  }
}

export default Accordion;
